import { firstValue } from 'helpers/utility';

/**
 * Given an async warning from the BE, get the membership from the object and return the ID, if that was the source of
 * validation error.
 * @param {Object} asyncWarning
 * @returns {Membership.id|undefined}
 */
export const getMembershipIdFromAsyncWarning = (asyncWarning) => firstValue(asyncWarning.memberships)?.id;
